/**
 * @file
 * Brand Accordion Tab component behaviors.
 *
 * @param {object} Drupal - The Drupal object.
 */

(function (Drupal) {
  'use strict';

  /**
   * Behavior for Brand Accordion Tab component.
   *
   * @type {object}
   */
  Drupal.behaviors.brandAccordionTab = {
    attach: function (context, settings) {
      // Add any JavaScript functionality for the accordion tab here if needed
      // Most of the interaction logic is handled by the parent accordion component
    }
  };

})(Drupal);
